import { render, staticRenderFns } from "./personCostTab.vue?vue&type=template&id=da8408ae&scoped=true&"
import script from "./personCostTab.vue?vue&type=script&lang=js&"
export * from "./personCostTab.vue?vue&type=script&lang=js&"
import style0 from "./personCostTab.vue?vue&type=style&index=0&id=da8408ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8408ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da8408ae')) {
      api.createRecord('da8408ae', component.options)
    } else {
      api.reload('da8408ae', component.options)
    }
    module.hot.accept("./personCostTab.vue?vue&type=template&id=da8408ae&scoped=true&", function () {
      api.rerender('da8408ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/tabPane/personCostTab.vue"
export default component.exports